/* eslint-disable @next/next/no-img-element */
'use client';
import AutoScroll from 'embla-carousel-auto-scroll';
import { useState } from 'react';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';

// import { DoctorDetails } from '@/app/specialists/doctor-card';
import { DoctorDetailsModal } from '@/app/specialists/doctor-card';
import { imageSrc } from '@/lib/imageSrc';
import { useGetDoctorsQuery } from '@/redux/api/doctorApi';
import { Mail, Phone } from 'lucide-react';
import Image from 'next/image';

const DoctorList = () => {
  const [open, setOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
  const { data, isError, isLoading } = useGetDoctorsQuery(undefined);
  const doctors = data?.body;

  const handleOpenModal = (doctor: any) => {
    setSelectedDoctor(doctor);
    setOpen(true);
  };

  if (isLoading) return null;

  if (isError) return null;

  return (
    <div>
      {' '}
      <Carousel
        opts={{
          align: 'start',
          loop: true,
        }}
        plugins={[
          AutoScroll({
            startDelay: 2000,
            speed: 1,
          }),
        ]}
        className="w-full"
      >
        <CarouselContent>
          {doctors?.map((data: any, index: number) => (
            <CarouselItem
              key={index}
              className="pl-5 md:basis-1/2 lg:basis-1/3"
            >
              <div className="group/social relative h-fit w-full overflow-hidden rounded-lg border bg-white">
                <div className="relative h-[300px] w-full overflow-hidden pt-2">
                  <Image
                    onClick={() => handleOpenModal(data)}
                    src={imageSrc(data?.image)}
                    alt={data.name}
                    fill={true}
                    className="h-full w-full object-contain transition-all duration-300 ease-in-out group-hover/social:scale-[1.1]"
                    loading="lazy"
                  />

                  <div className="absolute bottom-2 left-2/4 flex -translate-x-2/4 translate-y-[50px] items-center gap-4 opacity-0 transition-all duration-300 ease-in-out group-hover/social:translate-y-0 group-hover/social:opacity-100">
                    <a
                      href={`mailto:${data.contact.email}`}
                      className="hover:bg-primary-dark flex items-center justify-center rounded-full bg-primary p-2 text-white transition-colors"
                      title="Send Email"
                    >
                      <Mail className="h-5 w-5" />
                    </a>
                    <a
                      href={`tel:${data.contact.phone}`}
                      className="hover:bg-primary-dark flex items-center justify-center rounded-full bg-primary p-2 text-white transition-colors"
                      title="Call Doctor"
                    >
                      <Phone className="h-5 w-5" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-[#1d1d1f]">
                    {data.name}
                  </h3>
                  <p className="text-[#6e6e73]">
                    <span className="line-clamp-1">{data.description}</span>{' '}
                    <span
                      onClick={() => handleOpenModal(data)}
                      className="hover:text-primary-dark font-semibold text-primary"
                    >
                      See More
                    </span>
                  </p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <DoctorDetailsModal
        doctor={selectedDoctor}
        onClose={() => setSelectedDoctor(null)}
      />
    </div>
  );
};

export default DoctorList;
